import {createTheme} from '@sail/engine';
import {visualRefreshBadgeTheme} from './visualRefreshBadge';
import {visualRefreshRadioTheme} from './visualRefreshRadio';
import {visualRefreshTokens} from './visualRefreshTokens';
import {visualRefreshTypography} from './visualRefreshTypography';

/** The complete Dashboard visual refresh theme. */
export const visualRefresh = createTheme(
  {
    name: 'Visual Refresh',
    description: 'The complete Dashboard visual refresh theme.',
    category: 'Visual Refresh',
  },
  [
    visualRefreshTokens,
    visualRefreshTypography,
    visualRefreshBadgeTheme,
    visualRefreshRadioTheme,
  ],
);
